/**
 * Title.tsx — Renders `sectionData.title` as an `<h2>` heading.
 *
 * JSON trigger: `uiCompType.method: "renderTitle"`
 * Also used by `Panel` for the `title` key (renders as `<h1>` in that context).
 *
 * Delegates to `renderText(sectionData.title, 'title', {}, props, 'h2')`.
 * Full text directive support (STYLE=..., CLASS=..., bold, center, etc.) is
 * available via the `transformTextToHtml` pipeline.
 *
 * **Style slots:** `uiCompType.styles`, `uiCompType.className`.
 */
import React from "react";
import { SectionData, ComponentRenderProps, renderText } from "./index";

const Title = ({ sectionData, props }: { sectionData: SectionData, props: ComponentRenderProps }): JSX.Element | null => {
    return renderText(sectionData.title || "", "title", {} , props , 'h2') || null;
};

export default Title;
